import logo from '../../assets/img/logoVinet.svg';
import { DEFAULT_REDIRECT_URI } from '../../constants';
import React from 'react';
import { Trans, t } from '@lingui/macro';
import { useYupValidationForm } from '../../common/hooks/useYupValidationForm';
import * as yup from 'yup';
import { useLingui } from '@lingui/react';
import { Link } from 'react-router-dom';
import { forgotPassword } from '../../util/APIUtils';
import { error, success } from '../../util/toast';
import ChangeLang from '../change-lang';

import useIsTouchDevice from '../../common/hooks';

const validationSchema = yup.object({
  email: yup.string().email('Không đúng định dạng'),
});

export default function ForgotPassword() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useYupValidationForm(validationSchema);
  const { i18n } = useLingui();

  const isTouchDevice = useIsTouchDevice();

  document.title = i18n._(`Quên mật khẩu`);
  const onSubmit = (data) => {
    const reqData = data.email;
    forgotPassword(reqData)
      .then((rs) => {
        if (rs.ok) {
          success('Vui lòng kiểm tra lại email để đặt lại mật khẩu');
        }
      })
      .catch((err) => {
        console.log(err);
        error(
          (err && err.detail) ||
            'Oops! Something went wrong. Please try again!',
        );
      });
  };

  return (
    <div>
      {!isTouchDevice ? (
        <div className="block">
          <div className="md:pl-10 pt-5 w-screen">
            <div className="flex justify-end top-2 right-2">
              <ChangeLang />
            </div>
            <div className=" md:mr-auto md:ml-0 mx-auto w-40">
              <a href={DEFAULT_REDIRECT_URI}>
                <img src={logo} className="w-full mx-auto" alt="Logo VINET" />
              </a>
            </div>
          </div>
          <div className='md:mt-0 mt-16'>
            <div className="text-center font-bold md:text-4xl text-[26px] text-[#007DC5]">
              {i18n._('Quên mật khẩu')}
            </div>
            <div>
              <div className="md:block hidden text-center mt-10 font-bold text-xl">
                <Trans>Vui lòng nhập email để thay đổi mật khẩu</Trans>
              </div>
              <div className="md:hidden block text-center mt-5 font-medium text-xl">
               <Trans>Vui lòng nhập email để</Trans> <br/> <Trans>thay đổi mật khẩu</Trans>
              </div>
              <form
                className={'flex flex-col lg:w-[25%] w-11/12 mx-auto md:mt-10 mt-6'}
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className={' py-1 lg:py-3 lg:w-[75%] w-full mx-auto'}>
                  <div className={`font-bold mr-2 mt-1`}>Email</div>
                  <input
                    className={`w-full py-2 px-5 md:rounded-xl rounded-lg md:mt-0 mt-1 focus:ring outline-none border-2 ${
                      errors.email ? 'border-red-500' : 'border-gray-300'
                    }`}
                    placeholder={i18n._(t`Nhập địa chỉ email chính của bạn`)}
                    {...register('email')}
                  />
                  <div
                    className={`text-right text-red-500 font-bold mr-2 mt-1 text-sm`}
                  >
                    {errors.email?.message ? errors.email.message : <>&nbsp;</>}
                  </div>
                </div>
                  <button
                    className={'text-white bg-[#007DC5] py-2 lg:w-[75%] w-full mx-auto rounded-lg'}
                    type={'submit'}
                  >
                    <Trans>Gửi</Trans>
                  </button>
                <div className={`md:my-5 mx-auto text-center md:text-base text-sm mt-6`}>
                  <div>
                    <Trans>Bạn đã có tài khoản</Trans> ?
                    {" "}
                    <Link
                      to={'/'}
                      className={`text-primary hover:underline underline cursor-pointer`}
                    >
                   <Trans>Nhấn vào đây để đăng nhập</Trans>
                    </Link>
                  </div>

                </div>
              </form>
            </div>
          </div>
        </div>
      ) : (
        <div className="block">
          <div className="flex justify-end absolute top-2 right-2">
            <ChangeLang />
          </div>
          <div className="pt-20 text-center w-screen">
            <div className="w-full">
              <a href={DEFAULT_REDIRECT_URI}>
                <img
                  src={logo}
                  className="w-[166px] h-[61px] mx-auto"
                  alt="Logo VINET"
                />
              </a>
            </div>
          </div>
          <div>
            <div className="text-center font-bold text-[26px] pt-9 text-[#007DC5]">
              {i18n._('Quên mật khẩu')}
            </div>
            <div>
              <div className="text-center mt-4 font-medium text-[20px] mx-20 text-[#42526E] leading-[30px]">
                <Trans>Vui lòng nhập email để</Trans> <br/>
                <Trans>thay đổi mật khẩu</Trans>
              </div>
              <form
                className={'flex flex-col w-11/12 mx-auto mt-4'}
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className={'mx-2 py-1 lg:py-3'}>
                  <div className={`font-medium mr-2 my-1 text-[#172B4D]`}>
                    Email
                  </div>
                  <input
                    className={`w-full py-2 px-5 rounded-[8px] focus:ring outline-none border-[1px] ${
                      errors.email ? 'border-red-500' : 'border-gray-300'
                    }`}
                    placeholder={i18n._(t`Nhập địa chỉ email chính của bạn`)}
                    {...register('email')}
                  />
                  <div
                    className={`text-right text-red-500 font-bold mr-2 mt-1 text-sm`}
                  >
                    {errors.email?.message ? errors.email.message : <>&nbsp;</>}
                  </div>
                </div>
                <button className={'mx-auto py-3 w-8/12 px-12 text-white bg-[#007DC5] rounded-lg'} type={'submit'}>
                  <Trans>Gửi</Trans>
                </button>
                <div className={`mx-auto text-center text-[14px] mt-6`}>
                  <div className="text-[#172B4D]">
                    <Trans>Bạn đã có tài khoản</Trans>?
                    {" "}
                    <Link
                    to={'/'}
                    className={`text-[#007DC5] font-medium underline hover:underline ml-1 cursor-pointer `}
                  >
                   <Trans>Nhấn vào đây để đăng nhập</Trans>
                  </Link>

                  </div>

                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
